const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     examDate : {
        value: "",
        dbqName: "F[0].Page_1[0].DateOfExam[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_7[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section3[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section8[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis1[4]",
        }, 
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section4[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis1[1]",
        },   
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section5[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis2[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section6[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis1[2]",
        }, 
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section7[0]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis3[0]",
        },   
        {
            type: "checkbox",
            dbqName: "F[0].Page_1[0].Section7[1]",
            dateDbqName: "F[0].Page_1[0].DateOfDiagnosis1[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[5]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[2]",
        }, 
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[2]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[1]",
        },   
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[3]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[0]",
        }, 
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[1]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[0]",
        },  
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[4]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[2]",
        }, 
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Section8[6]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[3]",
        },       
    ]

}

export default ssn ;